<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="addpinjaman()"
            v-b-tooltip.hover
            title="input data pinjaman baru"
          >
            <i class="fa fa-floppy-o"></i> {{$t('save')}}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>

      <div slot="footer">
        <div class="text-center">
          <button
            class="btn btn-primary mr-1"
            @click="addpinjaman()"
            v-b-tooltip.hover
            title="input data pinjaman baru"
          >
            <i class="fa fa-floppy-o"></i> {{$t('save')}}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>
      <b-tabs content-class justified>
        <b-tab title="DATA DEBITUR" active>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">CIF</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.CustCode"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Salutation</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.salutation"
              :options="optionsSalutation"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Debitur Name</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.pemohon_name"
              placeholder
              :state="!$v.model.pemohon_name.$error"
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Tempat/ Tanggal lahir</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.tmptlahir"
              placeholder
              :state="!$v.model.tmptlahir.$error"
            ></b-form-input>
            <label>&nbsp;</label>
            <b-input
              type="date"
              v-model="model.tgllahir"
            />
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Nomor KTP/ Paspor*</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.nomoridentitas"
              placeholder
              :state="!$v.model.nomoridentitas.$error"
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">NPWP Pribadi</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.nonpwp"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Kewarganegaraan</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.kewarganegaraan"
              :options="optionsWNI"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
              :state="!$v.model.kewarganegaraan.$error"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Status Perkawinan</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.marital_status"
              :options="optionsMarried"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Jenis Kelamin</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.jnskelamin"
              :options="optionsJK"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Phone Selular</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.nohandphone"
              placeholder
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">E-mail</label>
            </b-input-group-prepend>
            <b-form-input
              type="email"
              v-model="model.email"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Agama</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.religion"
              :options="optionsReligion"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Nama Ibu Kandung</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.namaibu"
              :state="!$v.model.namaibu.$error"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Alamat Sesuai KTP</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.alamatktp"
              placeholder
              :state="!$v.model.alamatktp.$error"
            ></b-form-input>
          </b-input-group>

          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">RT.</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.rtktp"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">RW.</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.rwktp"
            ></b-form-input>
          </b-input-group>

          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kelurahan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kelurahanktp"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kecamatan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kecamatanktp"
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kotaktp"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.provinsiktp"
            ></b-form-input>
          </b-input-group>
          <b-input-group
            class="sub-section-input"
            style="width: calc(50% - 103px)"
          >
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kodeposktp"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">
                Alamat Tinggal
              </label>
            </b-input-group-prepend>
            <b-form-input v-model="model.alamat" placeholder></b-form-input>
          </b-input-group>

          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">RT.</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.rt"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">RW.</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.rw"
            ></b-form-input>
          </b-input-group>

          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kelurahan</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kelurahan"></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kecamatan</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kecamatan"></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.kota"></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="model.provinsi"></b-form-input>
          </b-input-group>
          <b-input-group
            class="sub-section-input"
            style="width: calc(50% - 103px)"
          >
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input placeholde v-model="model.kodepos"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Debitur Model</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.cust_model_code"
              :options="optionsCustModel"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Profession</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.prefession_code"
              :options="optionsProfession"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Coy Name</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.coy_name"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Coy Scale</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.coy_scale"
              :options="optionsCoyScale"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>
          
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Status Rumah Tinggal</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.statusrmhtinggal"
              :options="optionsHome"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Lama Tinggal</label>
            </b-input-group-prepend>
            <my-number
              style="max-width: 50px"
              class="form-control text-right"
              :precision="0"
              v-model="model.lamatinggalthn"
            ></my-number>
            <b-input-group-append>
              <label class="ml-sm-2 mt-1 mr-3">Tahun</label>
            </b-input-group-append>
            <my-number
              style="max-width: 50px"
              class="form-control text-right"
              :precision="0"
              v-model="model.lamatinggalbln"
            ></my-number>
            <label class="ml-sm-2 mt-1">Bulan</label>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Phone Area</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.phone_area"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Nomor Telepon Rumah</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.notlprumah" placeholder></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Jumlah Tanggungan</label>
            </b-input-group-prepend>
            <my-number
              style="max-width: 70px"
              v-model="model.jmltanggungan"
            ></my-number>
            <label class="ml-sm-2 mt-1">orang</label>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Pendidikan Terakhir</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.pendidikanterakhir"
              :options="optionsEdu"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
            <b-form-input
              v-if="model.pendidikanterakhir == '4'"
              placeholder="Sebutkan"
              v-model="model.pendidikanterakhirinput"
            ></b-form-input>
          </b-input-group>

        </b-tab>

        <b-tab title="DATA KELUARGA TERDEKAT">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Nama</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.namareferensi"
              placeholder
            ></b-form-input>
          </b-input-group>
              <!-- :state="!$v.model.namareferensi.$error" -->

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Hubungan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.hubunganreferensi"
              placeholder
            ></b-form-input>
          </b-input-group>
              <!-- :state="!$v.model.hubunganreferensi.$error" -->

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">
                Alamat Tempat Tinggal
                <br />Referensi Saat Ini
              </label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.alamatreferensi"
              placeholder
            ></b-form-input>
          </b-input-group>
              <!-- :state="!$v.model.alamatreferensi.$error" -->
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kelurahan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kelurahanreferensi"
            ></b-form-input>
              <!-- :state="!$v.model.kelurahanreferensi.$error" -->
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kecamatan</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kecamatanreferensi"
            ></b-form-input>
              <!-- :state="!$v.model.kecamatanreferensi.$error" -->
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kotareferensi"
            ></b-form-input>
              <!-- :state="!$v.model.kotareferensi.$error" -->
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.provinsireferensi"
            ></b-form-input>
              <!-- :state="!$v.model.provinsireferensi.$error" -->
          </b-input-group>
          <b-input-group
            class="sub-section-input"
            style="width: calc(50% - 103px)"
          >
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kodeposreferensi"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Nomor Telepon Rumah</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.notlpreferensi"
              placeholder
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 200px">Nomor Telepon Selular</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.nohpreferensi"
              placeholder
            ></b-form-input>
              <!-- :state="!$v.model.nohpreferensi.$error" -->
          </b-input-group>
        </b-tab>
        <b-tab title="DATA PEKERJAAN DEBITUR">
          <b-input-group>
            <b-input-group-prepend style="width: 200px">
              <label>Pekerjaan</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.tipepekerjaan"
              :options="optionsJob"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
              <!-- :state="!$v.model.tipepekerjaan.$error" -->
          </b-input-group>

          <b-input-group v-if="ifkaryawan">
            <b-input-group-prepend style="width: 200px">
              <label>
                Status Pekerjaan
                <br />(jika karyawan)
              </label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.statuspekerjaan"
              :options="optionsJobStatus"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
              <!-- :state="!$v.model.statuspekerjaan.$error" -->
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend style="width: 200px">
              <label>Nama Perusahaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.namaperusahaan"
              placeholder
            ></b-form-input>
              <!-- :state="!$v.model.namaperusahaan.$error" -->
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend style="width: 200px">
              <label>Alamat Perusahaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.alamatperusahaan"
              placeholder
            ></b-form-input>
              <!-- :state="!$v.model.alamatperusahaan.$error" -->
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kotaperusahaan"
            ></b-form-input>
              <!-- :state="!$v.model.kotaperusahaan.$error" -->
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Propinsi</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.provinsiperusahaan"
            ></b-form-input>
              <!-- :state="!$v.model.provinsiperusahaan.$error" -->
          </b-input-group>
          <b-input-group
            class="sub-section-input"
            style="width: calc(50% - 103px)"
          >
            <b-input-group-prepend>
              <label class="sub-section-label">Kodepos</label>
            </b-input-group-prepend>
            <b-form-input
              placeholder
              v-model="model.kodeposperusahaan"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend style="width: 200px">
              <label>Nomor Telepon Kantor</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.notlpperusahaan"
              placeholder
            ></b-form-input>
              <!-- :state="!$v.model.notlpperusahaan.$error" -->
            <b-input-group-prepend>
              <label class="sub-section-label mr-2 text-right"
                >Faks Kantor</label
              >
            </b-input-group-prepend>
            <b-form-input
              v-model="model.nofaxperusahaan"
              placeholder
            ></b-form-input>
          </b-input-group>
          <b-row>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend style="width: 200px">
                  <label>Lama Bekerja/usaha/praktek*</label>
                </b-input-group-prepend>
                <b-form-select
                  v-model="model.lamabekerja"
                  :options="optionsExp"
                  class="mb-3"
                ></b-form-select>
                  <!-- :state="!$v.model.lamabekerja.$error" -->
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group v-if="model.tipepekerjaan !== '0'">
            <b-input-group-prepend style="width: 200px">
              <label>
                Kepemilikan Tempat Usaha
                <br />(Jika profesional/wiraswasta)
              </label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.kepemilikanusaha"
              :options="optionsOwner"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
            ></b-form-radio-group>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend style="width: 200px">
              <label>Sebelumnya Bekerja Di</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.pekerjaansblm_tmpt"
              placeholder
            ></b-form-input>
            <label class="ml-sm-2 mt-1 mr-3"></label>
            <b-form-input
              style="max-width: 50px"
              placeholder
              v-model="model.lamakerjasblm_thn"
            ></b-form-input>
            <label class="ml-sm-2 mt-1 mr-3">Tahun</label>
            <b-form-input
              style="max-width: 50px"
              placeholder
              v-model="model.lamakerjasblm_bln"
            ></b-form-input>
            <label class="ml-sm-2 mt-1">Bulan</label>
          </b-input-group>
        </b-tab>
        <b-tab title="DATA KOLEKTOR">
          <!-- <h6 class="text-center page-header">Kolektor Aktif</h6> -->
          <div v-if="!$route.params.nasabahkey">
          <b-input-group>
            <b-input-group-prepend>
              <label>NIK</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="frmKolektor.crewnik"
              style="max-width: 250px"
            ></b-form-input>
            <b-input-group-append style="height: 35px">
              <b-btn text="Button" @click="showLkuCollector = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Collector Name</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewname }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kelamin</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >:
              {{
                frmKolektor.crewmale == "1" ? "Laki-Laki" : "Perempuan"
              }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Date Of Birth</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewdob | moment("DD-MMM-YYYY") }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewaddr }}</span
            >
          </b-input-group>
          <b-input-group class="sub-section-input" style="margin-left: 130px">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewcity }}</span
            >
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kode Pos</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewpost }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Email</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewmail }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>No HP</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewhp }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode</label>
            </b-input-group-prepend>
            <b-form-input
              type="date"
              v-model="frmKolektor.startdate"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >sampai</span
              ></b-input-group-prepend
            >
            <b-form-input
              type="date"
              v-model="frmKolektor.enddate"
            ></b-form-input>
          </b-input-group>
          </div>
          <b-card no-body class="mt-4" v-if="$route.params.nasabahkey">
            <!-- <template v-slot:header>
              
            </template> -->
             <div slot="header">
        Histori Kolektor
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="updateKolektorShow=true"
            v-b-tooltip.hover
            title="Pergantian kolektor"
          >
            <i class="fa fa-exchange"></i> Update Kolektor
          </button>
        </div>
      </div>
            
            <b-table
              class="mb-0"
              ref="tblhistorycollc"
              outlined
              responsive
              striped
              hover
              small
              style="font-size: smaller"
              :items="dataKolekAsign"
              :fields="tblFields"
              :current-page="tblData.page"
              :per-page="tblData.limit"
              :sort-by.sync="tblData.sortBy"
              :sort-desc.sync="tblData.sortDesc"
              :key="tblData.limit"
              show-empty
              @row-clicked="rowClicked"
            >
              <template v-slot:cell(index)="data">{{
                data.index + 1
              }}</template>
<!--               
              <template v-slot:cell(crewnik)="data"
                >{{diff(data.item) }}</template
              > -->
              <template v-slot:cell(custinfo)="data"
                >{{ data.item.CustCode }} | {{ data.item.CustName }}</template
              >
              <template v-slot:cell(startdate)="data">{{
                data.item.startdate | moment("DD-MMM-YYYY")
              }}</template>
              <template v-slot:cell(enddate)="data">{{
                data.item.enddate | moment("DD-MMM-YYYY")
              }}</template>
              <template v-slot:cell(isactive)="data">
                <span v-if="data.item.isactive">Active</span>
                <span v-else>Not Active</span>
                
              </template>
              <template v-slot:cell(show_details)="row" align-h="center">
                <div class="text-center">
                    <b-button @click="row.toggleDetails" size="sm" class="mr-2">
                      <i :class="row.detailsShowing?'fa fa-eye-slash':'fa fa-eye'" aria-hidden="true"></i>
                      {{ row.detailsShowing ? $t("hide") : $t("show") }}
                    </b-button>

                    <!-- <b-button @click="deletecolectordebitur(row.item)" size="sm" class="mr-2">
                      Delete
                    </b-button> -->
                </div>
              </template>
              <template v-slot:row-details="row">
                <b-card no-body>
                  <b-row class="mb-2">
                    <b-col>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">NIK</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.crewnik }}</span
                        >
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">Collector Name</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.crewname }}</span
                        >
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">Jenis Kelamin</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >:
                          {{
                            row.item.crewmale == "1" ? "Laki-Laki" : "Perempuan"
                          }}</span
                        >
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">Date Of Birth</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >:
                          {{ row.item.crewdob | moment("DD-MMM-YYYY") }}</span
                        >
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">Alamat</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.crewaddr }}</span
                        >
                      </b-input-group>
                      <b-input-group
                        class="sub-section-input"
                        style="margin-left: 130px"
                      >
                        <b-input-group-prepend>
                          <label class="sub-section-label">Kota</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.crewcity }}</span
                        >
                        <b-input-group-prepend>
                          <label class="sub-section-label text-right mr-2"
                            >Kode Pos</label
                          >
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.crewpost }}</span
                        >
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">Email</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.crewmail }}</span
                        >
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">No HP</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.crewhp }}</span
                        >
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend>
                          <label class="text-right">Periode</label>
                        </b-input-group-prepend>
                        <span class="form-control-plaintext text-left"
                          >: {{ row.item.startdate | moment('DD-MMM-YYYY')}} <strong>Sampai</strong> {{ row.item.enddate | moment('DD-MMM-YYYY') }}</span>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-card>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>
                  Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
                  to
                  <span v-if="tblData.page * tblData.limit > tblData.total">{{
                    tblData.total
                  }}</span>
                  <span v-else>{{ tblData.page * tblData.limit }}</span>
                  of {{ tblData.total }} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  label-cols="3"
                  label
                  style="margin-top: 0 !important"
                >
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25]"
                        :plain="true"
                        v-model="tblData.limit"
                        size="sm"
                        style="width: 80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblData.total"
                  :per-page="tblData.limit"
                  v-model="tblData.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal
      v-model="updateKolektorShow"
      size="lg"
      :hide-footer="true"
      title="Form Pergantian Kolektor"
      :centered="true"
    >
      <b-input-group>
            <b-input-group-prepend>
              <label>NIK</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="frmKolektor.crewnik"
              style="max-width: 250px"
            ></b-form-input>
            <b-input-group-append style="height: 35px">
              <b-btn text="Button" @click="showLkuCollector = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Collector Name</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewname }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kelamin</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >:
              {{
                frmKolektor.crewmale == "1" ? "Laki-Laki" : "Perempuan"
              }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Date Of Birth</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewdob | moment("DD-MMM-YYYY") }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewaddr }}</span
            >
          </b-input-group>
          <b-input-group class="sub-section-input" style="margin-left: 130px">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewcity }}</span
            >
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kode Pos</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewpost }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Email</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewmail }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>No HP</label>
            </b-input-group-prepend>
            <span class="form-control-plaintext"
              >: {{ frmKolektor.crewhp }}</span
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode</label>
            </b-input-group-prepend>
            <b-form-input
              type="date"
              v-model="frmKolektor.startdate"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >sampai</span
              ></b-input-group-prepend
            >
            <b-form-input
              type="date"
              v-model="frmKolektor.enddate"
            ></b-form-input>
          </b-input-group>
          <b-input-group v-if="$route.params.nasabahkey">
            <b-input-group-prepend>
              <label></label>
            </b-input-group-prepend>
            <button
              class="btn btn-primary mr-1"
              @click="updateKolektor()"
              v-b-tooltip.hover
              title="Simpan Pergantian Kolektor"
            >
              <i class="fa fa-floppy-o"></i> {{$t('save')}}
            </button>
          </b-input-group>
    </b-modal>
    <b-modal
      v-model="showLkuCollector"
      size="lg"
      :hide-footer="true"
      title="List Kolektor"
      :centered="true"
    >
      <lku-kolektor @click="onSelectLkukolektor"></lku-kolektor>
    </b-modal>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, minValue, requiredIf } from "vuelidate/lib/validators";
import apidebitur from "../../apis/debitur";
import lkuKolektor from "../../views/lookup/lkuCollector";
import debitur from "../../apis/debitur";
toastr.init();

export default {
  components: { myNumber, lkuKolektor},
  mixins: [validationMixin],
  validations: {
    model: {
      pemohon_name: { required },
      tmptlahir: { required },
      //tgllahir: { required },
      nomoridentitas: { required },
      //nonpwp: { required },
      kewarganegaraan: { required },
      marital_status: { required },
      //pendidikanterakhir: { required },
      alamatktp: { required },
      // kelurahanktp: { required },
      // kecamatanktp: { required },
      // kotaktp: { required },
      //provinsiktp: { required },
      //statusrmhtinggal: { required },
      //nohandphone: { required },
      //email: { required },
      namaibu: { required },
      // namareferensi: { required },
      // hubunganreferensi: { required },
      // alamatreferensi: { required },
      // kelurahanreferensi: { required },
      // kecamatanreferensi: { required },
      // kotareferensi: { required },
      // provinsireferensi: { required },
      // nohpreferensi: { required },
      // tipepekerjaan: { required },
      // statuspekerjaan: {
      //   required: requiredIf(function (value) {
      //     return this.ifkaryawan;
      //   }),
      // },
      // namaperusahaan: { required },
      // alamatperusahaan: { required },
      // kotaperusahaan: { required },
      // provinsiperusahaan: { required },
      // notlpperusahaan: { required },
      // lamabekerja: { required },
    },
    frmKolektor: {
      crewnik: { required },
      startdate: { required },
      enddate: { required },
    },
  },
  data() {
    return {
      showLkuCollector: false,
      updateKolektorShow:false,
      search: {
        no_kontrak: "",
        tgl_kontrak: "",
      },
      model: {
        pemohon_name: "",
        tmptlahir: "",
        tgllahir: moment().format('YYYY-MM-DD'),
        jnskelamin: "",
        nomoridentitas: "",
        nonpwp: null,
        kewarganegaraan: "WNI",
        marital_status: null,
        jmltanggungan: 0,
        pendidikanterakhir: "",
        pendidikanterakhirinput: "",
        alamatktp: "",
        kelurahanktp: "",
        kecamatanktp: "",
        kotaktp: "",
        provinsiktp: "",
        kodeposktp: "",
        alamat: "",
        kelurahan: "",
        kecamatan: "",
        kota: "",
        provinsi: "",
        kodepos: "",
        statusrmhtinggal: "",
        lamatinggalthn: 0,
        lamatinggalbln: 0,
        notlprumah: "",
        nohandphone: "",
        email: "",
        namaibu: "",
        // end nasabah
        // start referensi
        namareferensi: "",
        hubunganreferensi: "",
        alamatreferensi: "",
        kelurahanreferensi: "",
        kecamatanreferensi: "",
        kotareferensi: "",
        provinsireferensi: "",
        kodeposreferensi: "",
        notlpreferensi: "",
        nohpreferensi: "",
        //end referensi
        // start job
        tipepekerjaan: "",
        statuspekerjaan: "",
        namaperusahaan: "",
        alamatperusahaan: "",
        kotaperusahaan: "",
        provinsiperusahaan: "",
        kodeposperusahaan: "",
        notlpperusahaan: "",
        lamabekerja: null,
        kepemilikanusaha: 0,
        pekerjaansblm_tmpt: "",
        lamakerjasblm_thn: 0,
        lamakerjasblm_bln: 0,
      },
      frmKolektor: {
        startdate: moment().format("YYYY-MM-DD"),
        enddate: moment().add(1, "months").format("YYYY-MM-DD"),
      },
      optTipeJaminan: [
        { text: "Aset Tetap", value: "FA" },
        { text: "Kendaraan", value: "Kendaraan" },
      ],
      optStsSertifikat: [
        { text: "Hak Milik", value: "HM" },
        { text: "Hak Guna Bangunan", value: "HGB" },
        { text: "Hak Guna Usaha", value: "HGU" },
        { text: "Induk", value: "induk" },
        { text: "Lainnya", value: "lainnya" },
      ],
      optionsJK: [
        { item: "M", name: "Male" },
        { item: "F", name: "Female" },
      ],
      optionsSalutation: [
        { item: "MR", name: "MR" },
        { item: "MS", name: "MS" },
        { item: "MRS", name: "MRS" },
      ],
      optionsWNI: [
        { item: "WNI", name: "Indonesia" },
        { item: "WNA", name: "Warga Negara Asing" },
      ],
      optionsMarried: [
        { item: "MAR", name: "Married" },
        { item: "SIN", name: "Single" },
        { item: "DIV", name: "Divorce" },
        { item: "WID", name: "Widow" },
      ],
      optionsReligion: [
        { item: "ISLAM", name: "ISLAM" },
        { item: "KRISTEN", name: "KRISTEN" },
        { item: "KATHOLIK", name: "KATHOLIK" },
        { item: "HINDU", name: "HINDU" },
        { item: "BUDHA", name: "BUDHA" },
      ],
      optionsProfession: [
        { item: "PNS", name: "Pegawai Negeri Sipil" },
        { item: "IRT", name: "Ibu Rumah Tangga" },
        { item: "OTH", name: "Others" },
      ],
      optionsCustModel: [
        { item: "PROF", name: "Professional" },
        { item: "EMP", name: "Employee" },
      ],
      optionsCoyScale: [
        { item: "MEDIUM", name: "MEDIUM" },
        { item: "SMALL", name: "SMALL" },
        { item: "OTHERS", name: "OTHERS" },
      ],
      optionsEdu: [
        { item: "0", name: "SMA" },
        { item: "1", name: "Akademi/Diploma" },
        { item: "2", name: "S1" },
        { item: "3", name: "S2/S3" },
        { item: "4", name: "Lainnya" },
      ],
      optionsHome: [
        { item: "0", name: "Milik Keluarga" },
        { item: "1", name: "Milik Sendiri" },
        { item: "2", name: "Rumah Dinas" },
        { item: "3", name: "Kontral/Sewa" },
        { item: "4", name: "Kos" },
      ],
      optionsJob: [
        { item: "0", name: "Karyawan (Pegawai Negeri/BUMN/Swasta*)" },
        { item: "1", name: "Profesional" },
        { item: "2", name: "Wiraswasta" },
      ],
      optionsJobStatus: [
        { item: "0", name: "Pegawai Tetap" },
        { item: "1", name: "Pegawai Kontrak" },
      ],
      optionsExp: [
        { value: null, text: "-- Please select an option --", disabled: true },
        { value: "A", text: "> 10 Tahun" },
        { value: "B", text: "5-10 Tahun" },
        { value: "C", text: "2-5 Tahun" },
        { value: "D", text: "< 2 Tahun" },
      ],
      optionsOwner: [
        { item: "0", name: "Sendiri" },
        { item: "1", name: "Sewa" },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        nasabahkey: "",
        sortBy: "enddate",
        sortDesc: true,
      },
      kolektorDetail: {},
    };
  },
  props: ["modeldebitur"],
  async created() {
    this.model.modelkredit = this.modeldebitur;
    if (this.$route.params.nasabahkey) {
      toastr.info("Loading Debitur Detail, please wait");
      try {
        const nasabahkey = this.$route.params.nasabahkey;
        const [data] = await apidebitur.detail(nasabahkey);
        for (var key in data) {
          this.model[key] = data[key];
        }
        this.model.pemohon_name = data.CustName;
        this.model.nonpwp = data.npwp;
        this.model.tgllahir = data.tgllahir
            ? moment(data.tgllahir).format("YYYY-MM-DD")
            : "";
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmKolektor() {
      this.$v.model.$touch();
      return this.$v.frmKolektor.$invalid;
    },
    ifkaryawan() {
      return this.model.tipepekerjaan == "0" ? true : false;
    },
    ifMarried() {
      return this.model.marital_status == "0" ? true : false;
    },
    minage() {
      const date = moment(new Date(), "DD-MM-YYYY").add("years", 17);
      return moment(date).format("YYYY-MM-DD");
    },
    tblFields() {
      const fields = [
        {
          key: "index",
          thStyle: "width:50px",
          label: "No.",
        },
        {
          key: "crewnik",
          label: "NIK",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "collector_name",
          label: "Nama Kolektor",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "startdate",
          label: "Start",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "enddate",
          label: "End",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "isactive",
          label: "Status",
          thStyle: "width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "show_details",
          label: "Action",
          thClass: "text-center",
        },
      ];
      return fields;
    },
  },
  methods: {
    async changeduedate() {
      const startdate = this.model.startdate;
      const tenor = this.model.tenor;
      const date = moment(startdate).add(tenor, "M");
      this.model.duedate = moment(date).format("YYYY-MM-DD");
    },
    async addpinjaman() {
      try {
        if (this.invalidModel) {
          console.log("validation : ", this.$v.model);
          console.log("model obj : ", this.model);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          this.model.tgllahir = this.model.tgllahir ? moment(this.model.tgllahir).format("YYYY-MM-DD") : '';
          this.model.tgllahirpasangan = moment(
            this.model.tgllahirpasangan
          ).format("YYYY-MM-DD");
          if(this.frmKolektor.collector_id){
             this.model.frmKolektor = {
            nasabahkey: this.$route.params.nasabahkey,
            collector_id: this.frmKolektor.collector_id,
            collector_name: this.frmKolektor.crewname,
            startdate: this.frmKolektor.startdate,
            enddate: this.frmKolektor.enddate,
          };
          }
         console.log("#this.model.tgllahir: ", this.model.tgllahir);
         console.log("#this.model: ", this.model);
          await apidebitur.save(this.model);
          toastr.success("Data pinjaman berhasil disimpan", "Info");
          this.close();
        }
      } catch (error) {
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "loan.master-debitur" });
    },
    async dataKolekAsign() {
      if (this.$route.params.nasabahkey) {
        this.tblData.nasabahkey = this.$route.params.nasabahkey || "";
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const kolekasign = await apidebitur.collectorasignhistory(this.tblData);
        return kolekasign;
      } else {
        return [];
      }
    },
    onSelectLkukolektor(selected) {
      try {
        for (const key in selected) {
          this.frmKolektor[key] = selected[key];
        }
        this.showLkuCollector = false;
      } catch (error) {}
    },
    async updateKolektor() {
      if (this.invalidFrmKolektor) {
        toastr.error(this.$t("fill_form_correctly"), "ERROR MESSAGE");
      } else {
        try {
          const updateDt = {
            nasabahkey: this.$route.params.nasabahkey,
            collector_id: this.frmKolektor.collector_id,
            collector_name: this.frmKolektor.crewname,
            startdate: this.frmKolektor.startdate,
            enddate: this.frmKolektor.enddate,
          };

          await debitur.collectorassignment(updateDt);
          this.updateKolektorShow = false;
          for (const key in this.frmKolektor) {
            this.frmKolektor[key]='';
          }
          this.frmKolektor.startdate= moment().format("YYYY-MM-DD");
          this.frmKolektor.enddate= moment().add(1, "months").format("YYYY-MM-DD");
          toastr.success(this.$t("save_success"),'');
          this.$refs.tblhistorycollc.refresh()
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    async deletecolectordebitur(obj){
      try {
        //console.log("#obj: ", obj);
          await apidebitur.collectorasignhistorydelete(obj.collasignkey);
          toastr.success('Data berhasil dihapus');
          this.$refs.tblhistorycollc.refresh();
      } catch (error) {
        console.log('error',error)
      }
      
    },
    rowClicked(record, index) {
      if (this.kolektorDetail && this.kolektorDetail._rowVariant) {
        delete this.kolektorDetail._rowVariant;
      }
      this.kolektorDetail = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    diff(obj){
      var a = moment(obj.enddate);
      var b = moment(obj.startdate);
      console.log(a.diff(b));
    }
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-top: 4px !important;
}
.input-group {
  margin-top: 2px;
}
.lbl-left {
  width: 200px !important;
}
.sub-section-input {
  margin-left: 200px;
  width: calc(100% - 200px);
}
.sub-section-label {
  width: 150px;
}
.mynumb-penghasilan {
  max-width: 200px;
}
</style>